<stages-popup-header />
<div class="content">
	<h1
		[translate]="titleKey()"
		[translateParams]="{
			unavailableFrom: formatDate(maintenanceInfo().unavailableFrom),
			unavailableTo: formatDate(maintenanceInfo().unavailableTo),
			contact: maintenanceInfo().contact,
		}"
	></h1>
	<p
		class="panel"
		[translate]="messageKey()"
		[translateParams]="{
			unavailableFrom: formatDate(maintenanceInfo().unavailableFrom),
			unavailableTo: formatDate(maintenanceInfo().unavailableTo),
			contact: maintenanceInfo().contact,
		}"
	></p>

	<form class="form" [formGroup]="form" novalidate stagesFocusError>
		<div class="form-group">
			<div class="input-container md">
				<stages-input [form]="form" [input]="doNotShowAgainInput"></stages-input>
			</div>
		</div>
	</form>
</div>
<stages-popup-footer [buttons]="buttons" [hasCancelButton]="false" />
